import {icon} from '#core/utils/style-utils.js';

import {generateToggleButton} from '#core/application/modules/tiles/button/index.js';
import {generateSkeletonPart} from '#core/application/modules/tiles/skeleton-part/index.js';
import {generatePivotsRow} from '#core/application/modules/tiles/pivot/index.js';
import {constructTilePalette} from '#core/application/modules/tiles-cache.js';

export function inPlayPageFactory(PALETTE) {
    const {FONT} = PALETTE;

    const IN_PLAY_MENU_ROW = generatePivotsRow(
        constructTilePalette('PIVOT', null, PALETTE.INPLAY_SPORTS_SELECTOR.TOGGLE_BUTTON_BG)
    );

    return {
        InPlayMenu: {
            rootContainer: {
                style: {
                    fontFamily: FONT.FAMILY,
                    padding: '8px 0',
                    _mobile_padding: '8px 8px 0 8px',
                },
            },
            navigationMenuSkeleton: {
                linkPlaceholder: generateSkeletonPart(PALETTE.INPLAY_SPORTS_SELECTOR_SKELETON_PART),
            },
            navigationMenu: {
                item: generateToggleButton(PALETTE.INPLAY_SPORTS_SELECTOR, true, {
                    WITH_ACTIVE: false,
                    WITH_HOVER: false,
                }),
                itemIcon: icon(PALETTE.INPLAY_SPORTS_SELECTOR.TOGGLE_BUTTON_ICON_COLOR),
                selectedItemIcon: icon(PALETTE.INPLAY_SPORTS_SELECTOR.TOGGLE_BUTTON_SELECTED_ICON_COLOR),
                buttonScrollPane: IN_PLAY_MENU_ROW.buttonScrollPane,
            },
        },
    };
}
